import React from 'react';

import { FormScreenStyles as S } from './styles';

/**
 * Authored trade exclusions — "Not included as standard".
 * `compact` hides the note and nested sub-lines (Review).
 */
const TradeExclusionsCard = ({ exclusions, compact = false }) => {
  if (!exclusions?.lines?.length) return null;
  const twoCol = exclusions.lines.length >= 8;
  return (
    <S.ExclusionsCard>
      <S.ExclusionsTitle>Not included as standard</S.ExclusionsTitle>
      {!compact && exclusions.note ? <S.ExclusionsNote>{exclusions.note}</S.ExclusionsNote> : null}
      <S.ExclusionsList twoCol={twoCol}>
        {exclusions.lines.map((line, i) => (
          <S.ExclusionsItem key={`${line.text}-${i}`}>
            <S.ExclusionsText>{line.text}</S.ExclusionsText>
            {!compact && line.children?.length
              ? line.children.map((child, j) => (
                  <S.ExclusionsSubText key={`${child.text}-${j}`}>{child.text}</S.ExclusionsSubText>
                ))
              : null}
          </S.ExclusionsItem>
        ))}
      </S.ExclusionsList>
    </S.ExclusionsCard>
  );
};

export default TradeExclusionsCard;
